<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li @click="back"><span>{{$t('Hiragana_Practice')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Hiragana-Title-Pic.png) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">ひらがなドリル</div>
                  <div class="jp">{{$t('Hiragana_Practice')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="kanji-content mt30">
          <div class="disflex" style="justify-content: right;">
            <div class="Practice text-shadow mt20" style="margin-right:30px;" @click="getToAnswer()"><img style="transform: rotate(90deg);" src="../../static/images/up.png">{{$t('Practice')}}</div>
          </div>
        <div class="grammar-detail">
          <!-- 遍历每个部分 -->
          <div class="" v-for="(part, partIndex) in list" :key="partIndex">
            <div class="grammar-content mt30" style="border-bottom: 2px solid #2c3e5e;border-top: 2px solid #2c3e5e;padding: 30px 0;margin-bottom: 30px;">
              <div class="step1 disflex">
                <div class="step1-num text-shadow" :id="'Topic' + (partIndex + 1)">Q{{ partIndex + 1 }}</div>
                <div class="step1-content" style="width: 60%;">
                  {{$t('Katakana_tip_1')}} <br /> {{$t('Hiragana_tip_2')}}
                </div>
              </div>
            </div>
            <div class="answer-ul">
              <ul>
                <!-- 遍历当前部分的每个题目 -->
                <li v-for="(question, questionIndex) in part" :key="question.id" class="kanji-q-li">
                  <div class="as-title disflex">
                    <div class="num">{{ questionIndex + 1 }}</div>
                    <div class="as-t">
                      <!-- 题目音频播放按钮 -->
                      <button
                        @click="playQuestionAudio(question, partIndex, questionIndex)"
                        :class="{ 'image-grow': activeQuestionAudio === `${partIndex}-${questionIndex}` }"
                        class="audio-btn"
                      >
                        <img style="width: 36px;" src="../../static/images/yin2.png" alt="Play audio">
                      </button>
                      <audio
                        preload="auto"
                        :ref="`questionAudio${partIndex}-${questionIndex}`"
                        @ended="onQuestionAudioEnded(partIndex, questionIndex)"
                      >
                        <source :src="question.question_audio" type="audio/mp3">
                      </audio>
                    </div>
                  </div>

                  <ul class="as-ul disflex">
                    <!-- 遍历选项 -->
                    <li class="as-li disflex"
                        v-for="(option, optionIndex) in question.options"
                        :key="option.answer_num"
                        @click="selectAnswer(question, option, partIndex, questionIndex)">

                        <div class="input-i" :class="getOptionClass(question, option, partIndex, questionIndex)">
                          <span></span>
                        </div>
                        <div class="as-r">
                          <img width="50" :src="option.option_image" :alt="option.option_yin" />
                          <div class="option-yin">{{ option.option_yin }}</div>
                        </div>
                    </li>
                  </ul>

                  <!-- 答案反馈区域 -->
                  <!-- <div v-if="showCurrentAnswer[question.id]" class="answer-feedback">
                    <div class="feedback-text" :class="isAnswerCorrect(question) ? 'correct' : 'incorrect'">
                      {{ isAnswerCorrect(question) ? '✓ Correct!' : '✗ Incorrect' }}
                    </div>
                    <div class="correct-answer" v-if="!isAnswerCorrect(question) && userAnswers[question.id]">
                      Correct answer:
                      <span v-html="getCorrectAnswer(question)"></span>
                    </div>
                  </div> -->
                </li>
              </ul>

              <!-- 部分操作按钮 -->
              <div class="disflex" style="justify-content: center;">
                <div class="Practice text-shadow mt20"
                     :class="{ disabled: !isPartCompleted(part) }"
                     @click="showPartAnswers(part)">
                  {{$t('Answer')}}
                  <img src="../../static/images/up.png">
                </div>
                <div class="Practice try-again text-shadow mt20" style="margin-left:20px;" @click="resetPartAnswers(part)">
                  {{$t('Try Again')}}
                  <img width="28" src="../../static/images/Try-Again-Btn.png">
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>

<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'

export default {
    components: {
        Header, Dialog
    },
    data() {
      return {
        list: [],
        typeList: [],
        type: '',
        info: {},
        // 状态管理
        userAnswers: {}, // 存储用户答案 {题目id: 选择的答案编号}
        showCurrentAnswer: {}, // 存储当前显示的答案 {题目id: boolean}
        answeredQuestions: {}, // 存储已答题目 {题目id: boolean}
        activeQuestionAudio: null, // 当前播放的题目音频
        currentAudio: null // 当前播放的音频对象
      }
    },
    mounted() {
      // 在组件挂载后检查URL hash并滚动到对应位置
      this.$nextTick(() => {
        this.scrollToHash();
      });
    },
    watch: {
      // 监听路由变化，当hash变化时滚动到对应位置
      '$route'(to, from) {
        if (to.hash !== from.hash) {
          this.$nextTick(() => {
            this.scrollToHash();
          });
        }
      },
      // 监听list数据加载完成
      'list'() {
        // 数据加载完成后滚动到hash位置
        this.$nextTick(() => {
          this.scrollToHash();
        });
      }
    },
    created() {
      this.getList();
    },
    methods: {
      // 播放题目音频
      playQuestionAudio(question, partIndex, questionIndex) {
        const audioIndex = `${partIndex}-${questionIndex}`;
        const audioRef = `questionAudio${audioIndex}`;

        // 获取音频元素
        let audioElement = null;
        if (this.$refs[audioRef]) {
          audioElement = Array.isArray(this.$refs[audioRef])
            ? this.$refs[audioRef][0]
            : this.$refs[audioRef];
        }

        if (audioElement) {
          // 如果点击的是当前正在播放的音频，则暂停
          if (this.activeQuestionAudio === audioIndex && !audioElement.paused) {
            audioElement.pause();
            this.activeQuestionAudio = null;
            this.currentAudio = null;
          } else {
            // 暂停其他音频
            this.pauseAllQuestionAudios();
            // 播放当前音频
            this.activeQuestionAudio = audioIndex;
            this.currentAudio = audioElement;
            audioElement.currentTime = 0;
            audioElement.play().catch(e => {
              console.log("播放失败:", e);
              this.activeQuestionAudio = null;
              this.currentAudio = null;
            });
          }
        }
      },

      // 暂停所有题目音频
      pauseAllQuestionAudios() {
        if (this.currentAudio) {
          this.currentAudio.pause();
          this.currentAudio.currentTime = 0;
        }
        this.activeQuestionAudio = null;
        this.currentAudio = null;
      },

      // 题目音频播放结束
      onQuestionAudioEnded(partIndex, questionIndex) {
        const audioIndex = `${partIndex}-${questionIndex}`;
        if (this.activeQuestionAudio === audioIndex) {
          this.activeQuestionAudio = null;
          this.currentAudio = null;
        }
      },

      back(type){
        this.$router.push({path:'/Hiragana',query: {}});
      },
      getToDetail(item) {
        this.$router.push({path: '/HiraganaResult', query: {id: item.id}});
      },
      getList() {
        let that = this;
        that.$parent.loadModal(true);
        that.$api.post('/api/hiragana/question', null, r => {
          that.$parent.returnCode(r, function() {
            that.list = r.data;
            // 初始化状态
            that.initializeState();
            that.$parent.loadModal(false);
          });
        });
      },

      // 初始化状态
      initializeState() {
        this.list.forEach((part, partIndex) => {
          part.forEach(question => {
            this.$set(this.userAnswers, question.id, null);
            this.$set(this.showCurrentAnswer, question.id, false);
            this.$set(this.answeredQuestions, question.id, false);
          });
        });
      },

      // 滚动到hash对应的元素
      scrollToHash() {
        if (this.$route.hash) {
          const hash = this.$route.hash.slice(1); // 去掉#号
          const element = document.getElementById(hash);
          if (element) {
            // 计算元素位置并添加140px偏移
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 150;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      },

      // 选择答案
      selectAnswer(question, option, partIndex, questionIndex) {
        // 如果已经显示答案，则不允许修改
        if (this.showCurrentAnswer[question.id]) {
          return;
        }

        // 记录用户答案
        this.$set(this.userAnswers, question.id, option.answer_num);
        this.$set(this.answeredQuestions, question.id, true);

        // 自动隐藏其他题目的答案显示
        this.hideOtherAnswers(question.id, partIndex);
      },

      // 隐藏其他题目的答案显示
      hideOtherAnswers(currentQuestionId, partIndex) {
        const part = this.list[partIndex];
        if (part) {
          part.forEach(question => {
            if (question.id !== currentQuestionId) {
              this.$set(this.showCurrentAnswer, question.id, false);
            }
          });
        }
      },

      // 获取选项样式类
      getOptionClass(question, option, partIndex, questionIndex) {
        const userAnswer = this.userAnswers[question.id];
        const isShowingAnswer = this.showCurrentAnswer[question.id];
        const isSelected = userAnswer === option.answer_num;
        const isCorrectAnswer = option.answer_num === question.question_answer;

        // 如果没有显示答案，只显示选中状态
        if (!isShowingAnswer) {
          return isSelected ? 'active' : '';
        }

        // 显示答案时的状态
        if (isCorrectAnswer) {
          // 正确答案
          return 'correct';
        } else if (isSelected && !isCorrectAnswer) {
          // 用户选择的错误答案
          return 'incorrect';
        }

        // 其他未选中的选项
        return '';
      },

      // 检查答案是否正确
      isAnswerCorrect(question) {
        return this.userAnswers[question.id] === question.question_answer;
      },

      // 获取正确答案
      getCorrectAnswer(question) {
        const correctOption = question.options.find(opt => opt.answer_num === question.question_answer);
        return correctOption ? correctOption.option_yin : '';
      },

      // 检查当前部分是否完成
      isPartCompleted(part) {
        if (!Array.isArray(part)) return false;
        return part.every(question => this.answeredQuestions[question.id]);
      },

      // 显示当前部分的答案
      showPartAnswers(part) {
        if (!Array.isArray(part) || !this.isPartCompleted(part)) {
          return; // 题目未完成，不执行操作
        }

        // 显示该部分所有题目的答案
        part.forEach(question => {
          this.$set(this.showCurrentAnswer, question.id, true);
        });
      },

      // 重置当前部分的答案
      resetPartAnswers(part) {
        if (!Array.isArray(part)) return;

        part.forEach(question => {
          this.$set(this.userAnswers, question.id, null);
          this.$set(this.showCurrentAnswer, question.id, false);
          this.$set(this.answeredQuestions, question.id, false);
        });
      },

      getToAnswer(type){
        this.$router.push({path:'/Hiragana',query: {}});
      },

      closeBuyPopup() {
        this.$refs.levelDialog.closeMask();
        this.$router.push({path: '/', query: {}});
      },

      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      }
    }
}
</script>

<style scoped>
.audio-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.audio-btn:hover {
  background-color: rgba(0,0,0,0.1);
}

.image-grow {
  transform: scale(1.1);
  transition: transform 0.3s;
}

.option-yin {
  margin-top: 5px;
  font-size: 14px;
  color: #333;
}

.answer-feedback {
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}

.feedback-text.correct {
  color: green;
  font-weight: bold;
}

.feedback-text.incorrect {
  color: red;
  font-weight: bold;
}

.correct-answer {
  margin-top: 5px;
  color: #666;
}

/* 选项样式 */
.input-i.active {
  background-color: #4CAF50;
}

.input-i.correct {
  background-color: #4CAF50;
}

.input-i.incorrect {
  background-color: #f44336;
}

.Practice.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/page/HiraganaLearn.vue